import { formatCurrency } from "../../../helpers";
import { formatDate } from "../../../helpers/date";

export const CALL_DETAIL_COLUMNS = [
  {
    Header: "Tech",
    accessor: "assigned_to.full_name",
    id: "assigned_to",
    minWidth: 180
  },
  {
    Header: "Dept",
    id: "department",
    accessor: "department.code",
    minWidth: 80
  },
  {
    Header: "Stage",
    id: "stage",
    accessor: "stage.label",
    minWidth: 100
  },
  {
    Header: "Comp Dt",
    accessor: "completed_date",
    id: "completed_date",
    Cell: ({ value }) => (value ? formatDate(value, "MM/dd/yyyy") : ""),
    minWidth: 120
  },
  {
    Header: "Workplace",
    accessor: "workplace.label",
    id: "workplace",
    minWidth: 100
  },
  {
    Header: "Customer",
    accessor: "customer.name",
    id: "customer",
    minWidth: 200
  },
  {
    Header: "Project",
    accessor: "project.name",
    id: "project.name",
    minWidth: 200
  },
  {
    Header: "Project Type",
    accessor: "product_category.label",
    id: "project_category",
    minWidth: 100
  },
  {
    Header: "Department Category",
    id: "department_category",
    accessor: "department_category.name",
    minWidth: 80
  },
  {
    Header: "Call Type",
    id: "call_type",
    accessor: "call_type.label",
    minWidth: 120
  },
  {
    Header: "Service Description",
    id: "service",
    accessor: "service.description",
    minWidth: 180
  },
  {
    Header: "Off Hours",
    id: "off_hours",
    accessor: "off_hours",
    Cell: ({ value }) => (value ? "True" : ""),
    minWidth: 80
  },
  {
    Header: "Actual Hours",
    id: "actual_hrs",
    accessor: "actual_hrs",
    Cell: ({ value }) =>
      Number(value)?.toFixed(2) !== "NaN" ? Number(value)?.toFixed(2) : "0.00",
    minWidth: 100
  },
  {
    Header: "Billable Hours",
    id: "billable_hrs",
    accessor: "billable_hrs",
    Cell: ({ value }) =>
      Number(value)?.toFixed(2) !== "NaN" ? Number(value)?.toFixed(2) : "0.00",
    minWidth: 100
  },
  {
    Header: "Billing Rate",
    id: "project.rate",
    accessor: "project.rate",
    Cell: ({ value }) => formatCurrency(value || 0),
    minWidth: 100
  },
  {
    Header: "Ticket #",
    accessor: "support_ticket.support_ticket_number_str",
    id: "support_ticket_id",
    minWidth: 100
  },
  {
    Header: "Requestor",
    id: "project_requestor",
    accessor: "project_requestor",
    minWidth: 180
  },
  {
    Header: "Resolv Dt Timestamp",
    accessor: "resolved_date",
    id: "resolved_date",
    Cell: ({ value }) =>
      value ? formatDate(value, "MM/dd/yyyy, hh:mm a") : "",
    minWidth: 180
  },
  {
    Header: "Billing Description",
    id: "billing_description",
    accessor: "billing_description",
    minWidth: 250
  },
  {
    Header: "Internal Note",
    id: "internal_notes",
    accessor: "internal_notes",
    minWidth: 250
  },
  {
    Header: "Manager Note",
    id: "review_notes",
    accessor: "review_notes",
    minWidth: 250
  }
];
